function isFunction(f) {
    return f && {}.toString.call(f) === '[object Function]';
}

function validateRule(key, val, value, model) {
    if (key === 'required' && val === true && !value) {
        return 'error.required';
    }
    if (isFunction(val)) {
        return val(value, model);
    }
}

export function isValidPassword(v) {
    v = v || '';
    return (
        v.length >= 8 &&
        v.length <= 20 &&
        v.match(/[a-zA-Z]/) &&
        v.match(/[0-9]/)
    );
}

export const validate = function(errors, model, rules) {
    const _errors = {};

    Object.entries(rules).forEach(([field, r]) => {
        let _fieldRules = Object.entries(r).sort(a => {
            return a[1] === 'required' ? -1 : 0;
        });

        _fieldRules.some(([key, val]) => {
            const msg = validateRule(key, val, model[field], model);
            if (msg) {
                _errors[field] = msg;
                return true;
            }
        });
    });
    return {
        errors: _errors,
        hasError: Object.entries(_errors).length > 0
    };
};
